<template>
  <div class="verified-badge">
    <CheckGeneric class="h-5 w-5 mr-1" />
    {{ $t('review.verifiedLabel') }}
  </div>
</template>
<script lang="ts" setup>
import CheckGeneric from '~/assets/icons/check-generic.svg?component'
</script>
<style lang="postcss" scoped>
.verified-badge {
  @apply flex;
  @apply bg-lime-100 border-teal-900 border;
  @apply rounded-md pr-2 pl-1;
  @apply text-teal-900 text-sm;
}
</style>
